// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"4ceac46c","127":"dd934a26","157":"c604e511","189":"987e0e0d","190":"db86c727","298":"54390fa4","332":"b49ea803","453":"03346f77","516":"1b1676e8","522":"759e8a30","534":"557b2d0c","553":"d3a129c9","632":"824c6c00"}[chunkId] + ".chunk.js";
};